import Notification from "../../components/Notification";
import {useSelector} from "react-redux";
import {FaceCool} from "@carbon/icons-react";
import {Heading} from "@carbon/react";
import {useMemo} from "react";
import {selectNotifications} from "../../features/application/applicationSlice";
import { useTranslation } from "react-i18next";

const Index = () => {
    const { t } = useTranslation();
    const notifications = useSelector(selectNotifications)
    
    const notificationItems = useMemo(() => 
        notifications.map((notification) => (
            <div key={notification.id} className="notification-item">
                <Notification notification={notification} persistent={true} />
            </div>
        )), [notifications]
    );
    
    return (
        <div className="page-container">
            <Heading className="notifications-heading">{t("notifications.title")}</Heading>
            <div className="notifications-grid">
                {notificationItems}
            </div>
            {notifications.length === 0 &&
                <div className="no-notifications">
                    <h2>{t("notifications.empty")}</h2>
                    <FaceCool size={32}/>
                </div>
            }
        </div>
    )


}

export default Index
